import { Component, Input } from '@angular/core';

import { User } from '../../services/users/users.model';

export type RingColor = 'red' | 'green' | 'amber' | 'white' ;
export type Size = 'xs' | 'sm' | 'lg' | 'xl' ;

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css'
})
export class AvatarComponent {
  
  @Input()
  user?: User  ;

  @Input()
  size: Size = 'sm' ;

  @Input()
  ringColor?: RingColor ;

  get imgUrl(): string | undefined {

    if (!this.user || !this.user.profileImage) {
      return undefined ;
    }

    switch(this.size) {
      case "xl":
        return `${this.user.profileImage}/512.jpg` ;
      case "lg":
        return `${this.user.profileImage}/256.jpg` ;
      case "sm":
      case "xs":
        return `${this.user.profileImage}/128.jpg` ;
    }

    return "" ;
  }

  get initials(): string {
    if (!this.user) {
      return "" ;
    }

    return this.user.givenName.charAt(0) + this.user.familyName.charAt(0) ;
  }

  get classes(): string[] {

    const classes = ["avatar-" + this.size]

    if (this.ringColor == 'red') {
      classes.push("ring-red", "border-4") ;
    } else if (this.ringColor == 'green') {
      classes.push("ring-green", "border-4");
    } else if (this.ringColor == 'amber') {
      classes.push("ring-amber", "border-4");
    } else if (this.ringColor == 'white') {
      classes.push("border-white", "border-4");
    } else {
      classes.push("border-slate-600", "border-2") ;
    }

    return classes ;
  }

  get initialsClass(): string
  {

    switch( this.size) {
      case 'xs':
        return "text-xl" ;
      case 'sm':
        return "text-2xl" ;
      case 'lg':
        return "text-6xl" ;
      case 'xl':
        return "text-8xl" ;
    }

  }

}
